var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({height: _vm.reload ? `${_vm.height}px` : 'auto'})},[(!_vm.reload)?_c('editor',{ref:"tinymceReft",attrs:{"init":_vm.init,"disabled":_vm.disabled},on:{"change":_vm.changeHandler},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }